import React, { useEffect, useState } from "react";
import heroBanner from "../assets/images/hero-banner.png";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import servicethumbnail from "../assets/images/service-thumbnail.png";
import systemintegration from "../assets/images/System Integration.png";
import dataintegration from "../assets/images/Data Integration.png";
import apimanagement from "../assets/images/API Management.png";
import cloudintegration from "../assets/images/Cloud Integration.png";
import businessintegration from "../assets/images/Business Integration.png";
import securitycompliance from "../assets/images/Security and Compliance.png";
import changemanagement from "../assets/images/Change Management.png";
import digitalmarketing from "../assets/images/Digital Marketing.png";
import connectionbanner from "../assets/images/connection-banner.png";
import { Link } from "react-router-dom";
import "../styles/bubbles.css";
import "../styles/style.css";

function Services() {
  
  return (

      <>
    
      <Helmet>
      <title>Entegation Technologies | Services</title>
        <link href="https://unpkg.com/aos@2.3.1/dist/aos.css" rel="stylesheet"/>    
       <script src="https://unpkg.com/aos@2.3.1/dist/aos.js"></script>
        <script src="/assets/js/script.js"></script>
      </Helmet>

      {/* <!-- preloader --> */}
      {/* <div id="preloader">
      <div className="preloader">
        <span></span>
        <span></span>
      </div>
    </div> */}
      {/* <!-- preloader end  --> */}

      {/* <!-- Mouse Cursor Start -->   */}
      <div className="mouse-cursor cursor-outer"></div>
      <div className="mouse-cursor cursor-inner"></div>

      <header
        className="top-header inner-banner"
        style={{ background: `url(${heroBanner}) no-repeat top center` }}
      >
        <div id="stars"></div>
        <div id="stars2"></div>
        <div id="stars3"></div>
        <Navbar />
        <section className="banner-caption flex-center">
          <div className="caption-header text-white">
            <div className="container text-center">
              <h1 className="caption-title">
                {" "}
                Empowering Your Business <br />
                Through Seamless Integration{" "}
              </h1>
              <p className="col-lg-8 mx-auto caption-sub-title pt-3 text-white">
                {" "}
                Tailored Solutions to Drive Efficiency and Innovation{" "}
              </p>
            </div>
          </div>
        </section>
      </header>
      <section className="home-about light-gradient-bg py-5">
        <div className="container">
          <div className="row py-5 align-items-center">
            <div className="col-lg-8">
              <div className="column-left">
                <div className="title mb-5">
                  <h1 className="section-title">Our Services</h1>
                </div>
                <div className="column-left-content home-about-content">
                  <p className="mb-0">
                    {" "}
                    At Entegation Technologies, we offer a comprehensive range
                    of technology integration services designed to meet the
                    unique needs of your business. Our expert team specializes
                    in connecting diverse systems, optimizing data flow, and
                    ensuring that your technology infrastructure works
                    seamlessly.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="column-right">
                <div className="home-about-right d-flex justify-content-end">
                  <div className="thumbnail-block">
                    <div className="card-image">
                      <img
                        src={servicethumbnail}
                        alt="About-image"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container service-listed-block pb-5">
        <div className="row column-list-item pb-3">
          <div
            data-aos="fade-up"
            data-aos-delay="150"
            data-aos-duration="1000"
            className="col-lg-6"
          >
            <div className="list-card">
              <div className="list-icon mb-5">
                <img src={systemintegration} alt="System-icon" />
              </div>
              <div className="list-details">
                <div className="column-title mb-4">
                  <h1>System Integration</h1>
                </div>
                <div className="item-list">
                  <ul className="list-unstyled">
                    <li>
                      {" "}
                      Connecting disparate systems and platforms to create a
                      unified and efficient workflow.{" "}
                    </li>
                    <li>
                      {" "}
                      Migrating data between systems to ensure continuity and
                      accuracy.{" "}
                    </li>
                    <li>
                      {" "}
                      Integrating on-premises and cloud-based solutions for
                      maximum flexibility.{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- 2 --> */}
          <div
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1500"
            className="col-lg-6"
          >
            <div className="list-card">
              <div className="list-icon mb-5">
                <img src={dataintegration} alt="System-icon" />
              </div>
              <div className="list-details">
                <div className="column-title mb-4">
                  <h1>Data Integration</h1>
                </div>
                <div className="item-list">
                  <ul className="list-unstyled">
                    <li>
                      {" "}
                      Unifying data from various sources to provide a
                      comprehensive view of your business.{" "}
                    </li>
                    <li>
                      {" "}
                      Cleaning and standardizing data to improve quality and
                      accuracy.{" "}
                    </li>
                    <li>
                      {" "}
                      Implementing data governance strategies to protect
                      sensitive information.{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- 3 --> */}
          <div
            data-aos="fade-up"
            data-aos-delay="150"
            data-aos-duration="1000"
            className="col-lg-6"
          >
            <div className="list-card">
              <div className="list-icon mb-5">
                <img src={apimanagement} alt="System-icon" />
              </div>
              <div className="list-details">
                <div className="column-title mb-4">
                  <h1>API Management</h1>
                </div>
                <div className="item-list">
                  <ul className="list-unstyled">
                    <li>
                      {" "}
                      Developing and managing APIs to facilitate communication
                      between different applications.{" "}
                    </li>
                    <li> Ensuring secure and scalable API integration. </li>
                    <li> Providing API documentation and support. </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- 4 --> */}
          <div
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1500"
            className="col-lg-6"
          >
            <div className="list-card">
              <div className="list-icon mb-5">
                <img src={cloudintegration} alt="System-icon" />
              </div>
              <div className="list-details">
                <div className="column-title mb-4">
                  <h1>Cloud Integration</h1>
                </div>
                <div className="item-list">
                  <ul className="list-unstyled">
                    <li>
                      {" "}
                      Migrating applications and data to cloud platforms.{" "}
                    </li>
                    <li>
                      {" "}
                      Integrating cloud-based services with on-premises systems.{" "}
                    </li>
                    <li> Optimizing cloud usage for cost-effectiveness. </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- 5 --> */}
          <div
            data-aos="fade-up"
            data-aos-delay="150"
            data-aos-duration="1000"
            className="col-lg-6"
          >
            <div className="list-card">
              <div className="list-icon mb-5">
                <img src={businessintegration} alt="System-icon" />
              </div>
              <div className="list-details">
                <div className="column-title mb-4">
                  <h1>Business Process Integration</h1>
                </div>
                <div className="item-list">
                  <ul className="list-unstyled">
                    <li>
                      {" "}
                      Aligning technology with your business processes to
                      improve efficiency.{" "}
                    </li>
                    <li>
                      {" "}
                      Automating repetitive tasks to reduce manual effort.{" "}
                    </li>
                    <li> Streamlining workflows to enhance productivity. </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- 6 --> */}
          <div
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1500"
            className="col-lg-6"
          >
            <div className="list-card">
              <div className="list-icon mb-5">
                <img src={securitycompliance} alt="System-icon" />
              </div>
              <div className="list-details">
                <div className="column-title mb-4">
                  <h1>Security and Compliance</h1>
                </div>
                <div className="item-list">
                  <ul className="list-unstyled">
                    <li>
                      {" "}
                      Implementing robust security measures to protect your
                      data.{" "}
                    </li>
                    <li>
                      {" "}
                      Ensuring compliance with industry regulations and
                      standards.{" "}
                    </li>
                    <li>
                      {" "}
                      Conducting regular security assessments and audits.{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- 7 --> */}
          <div
            data-aos="fade-up"
            data-aos-delay="150"
            data-aos-duration="1000"
            className="col-lg-6"
          >
            <div className="list-card">
              <div className="list-icon mb-5">
                <img src={changemanagement} alt="System-icon" />
              </div>
              <div className="list-details">
                <div className="column-title mb-4">
                  <h1>Change Management</h1>
                </div>
                <div className="item-list">
                  <ul className="list-unstyled">
                    <li>
                      {" "}
                      Planning and executing technology changes to minimize
                      disruption.{" "}
                    </li>
                    <li> Providing training and support to employees. </li>
                    <li>Managing stakeholder expectations.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- 8 --> */}
          <div
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1500"
            className="col-lg-6"
          >
            <div className="list-card">
              <div className="list-icon mb-5">
                <img src={digitalmarketing} alt="System-icon" />
              </div>
              <div className="list-details">
                <div className="column-title mb-4">
                  <h1>Digital Marketing</h1>
                </div>
                <div className="item-list">
                  <ul className="list-unstyled">
                    <li>
                      {" "}
                      Data-driven digital marketing strategies to boost your
                      online presence.{" "}
                    </li>
                    <li>
                      {" "}
                      SEO, social media, content marketing, and paid ads to
                      increase traffic and engagement.{" "}
                    </li>
                    <li>
                      {" "}
                      Performance analysis to optimize campaigns & maximize ROI.{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="approach light-bg-column py-5 mb-5 service-count">
        <div className="container">
          <div className="row py-5 gx-5">
            <div className="col-12 text-center">
              <div className="title mb-5">
                <h1 className="section-title mb-5"> Why Choose Entegation? </h1>
              </div>
            </div>
            <div className="col-lg-6 border-right-full border-bottom-line-left pb-5">
              <div className="list-approach text-center">
                <div className="list-icon mb-5">
                  <span>01</span>
                </div>
                <div className="column-title mb-4">
                  <h1>Expertise and Experience</h1>
                </div>
                <div className="column-content ps-lg-5 pe-lg-5 pb-3">
                  <p className="ps-lg-5 pe-lg-5">
                    {" "}
                    Our team of experts has a deep understanding of technology
                    integration and can deliver tailored solutions to meet your
                    specific needs.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 border-bottom-line-right">
              <div className="list-approach text-center">
                <div className="list-icon mb-5">
                  <span>02</span>
                </div>
                <div className="column-title mb-4">
                  <h1>Customized Approach</h1>
                </div>
                <div className="column-content ps-lg-5 pe-lg-5">
                  <p className="ps-lg-5 pe-lg-5">
                    {" "}
                    We work closely with you to understand your unique business
                    requirements and develop solutions that align with your
                    goals.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 border-right-full">
              <div className="list-approach text-center pt-5">
                <div className="list-icon mb-5">
                  <span>03</span>
                </div>
                <div className="column-title mb-4">
                  <h1>Proven Results</h1>
                </div>
                <div className="column-content ps-lg-5 pe-lg-5">
                  <p className="ps-lg-5 pe-lg-5">
                    {" "}
                    Our track record of successful projects demonstrates our
                    ability to deliver tangible benefits to our clients.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="list-approach text-center pt-5">
                <div className="list-icon mb-5">
                  <span>04</span>
                </div>
                <div className="column-title mb-4">
                  <h1>Commitment to Excellence</h1>
                </div>
                <div className="column-content ps-lg-5 pe-lg-5">
                  <p className="ps-lg-5 pe-lg-5">
                    {" "}
                    We strive for the highest standards of quality and customer
                    satisfaction in everything we do.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bottom-bg py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="dark-bg-block">
                <div className="tech-integration d-flex align-items-center">
                  <div className="col-lg-4">
                    <div className="contact-info-block text-white">
                      <p className="py-4">
                        {" "}
                        Ready to elevate your business with seamless technology
                        integration? Contact us today to schedule a consultation
                        and learn how we can help you achieve your goals.{" "}
                      </p>
                      <Link to="contact-us" className="btn btn-outline-white">
                        Let's Talk
                      </Link>
                    </div>
                  </div>
                  <div className="col">
                    <div className="connection-banner d-flex justify-content-end">
                      <img
                        src={connectionbanner}
                        alt="Integration banner"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- footer --> */}
      <Footer />
      <div className="progress-wrap">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>

      </>
    
  );
}

export default Services;
